import { useEffect, useRef } from "react"
import { aWatchedSeconds, useSetAtom } from "~/atoms"

export function useWatchedSeconds({
  isPlaying,
  isBuffering,
}: {
  isPlaying: boolean
  isBuffering: boolean
}) {
  const setWatchedSeconds = useSetAtom(aWatchedSeconds)
  const watchedSecondsRef = useRef(0)
  const lastTickRef = useRef<number | null>(null)

  useEffect(() => {
    if (!isPlaying || isBuffering) return
    lastTickRef.current = Date.now()
    const interval = setInterval(() => {
      const now = Date.now()
      const elapsed = (now - lastTickRef.current!) / 1000
      watchedSecondsRef.current += elapsed
      setWatchedSeconds(watchedSecondsRef.current)
      lastTickRef.current = now
    }, 250)
    return () => clearInterval(interval)
  }, [isPlaying, isBuffering])
}
